export default "__VITE_ASSET__D$KIbutM__"